module.exports = __webpack_public_path__ + "img/checkup-img-bg@3x.fe65ea7a.png";